import React from "react";

function Statement({ colorCode = "" }) {
  return (
    <svg
      className="MuiSvgIcon-root"
      viewBox="0 0 22 25"
      style={{ fill: "transparent" }}
    >
      <path
        d="M13.2988 1H4.09883C3.48883 1 2.90382 1.24232 2.47248 1.67365C2.04115 2.10499 1.79883 2.69 1.79883 3.3V21.7C1.79883 22.31 2.04115 22.895 2.47248 23.3263C2.90382 23.7577 3.48883 24 4.09883 24H17.8988C18.5088 24 19.0938 23.7577 19.5252 23.3263C19.9565 22.895 20.1988 22.31 20.1988 21.7V7.9L13.2988 1Z"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2988 1V7.9H20.1988"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5987 13.65H6.39868"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5987 18.25H6.39868"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.69868 9.04999H7.54868H6.39868"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Statement;
